import styled from "styled-components";
import { COLORS } from "../../../../layout/theme";
import { Input, Table } from "antd";

export const Inner = styled.div`
	padding: 20px 10px;
`;
export const AntdTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: ${COLORS.Primary};
  }

  .ant-table-row {
    background: ${COLORS.White};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${COLORS.Primary};

    div {
      color: ${COLORS.Primary};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TableContainer = styled.div`
	.ant-table table {
		background-color: ${COLORS.LightGrey} !important;
	}
`;

export const CompaginationDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 18px;

	.ant-btn {
		width: 34px;
		height: 34px;
		border-radius: 999px;
		border: 1px solid #d1d5db;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: none;
	}
`;

export const AntdInput = styled(Input)`
	.ant-input-group .ant-input {
		height: 30px;
		border: 1px solid #cbd5e1;
		border-radius: 12px 0 0 12px;
		background-color: ${COLORS.White};
		text-align: center;
		padding: 5px 8px;
		font-weight: 600;
		color: #334155;
	}

	.ant-input-group .ant-input:hover,
	.ant-input-group .ant-input:focus {
		border: 1px solid #4f46e5;
		box-shadow: none;
	}

	.ant-input-group-addon {
		border: 1px solid #cbd5e1;
		border-left: 0;
		background-color: ${COLORS.White};
		padding: 0 10px;
		border-radius: 0 12px 12px 0;
		color: #64748b;
		font-weight: 600;
	}
`;

export const Circle = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${(props) => props.color || "#ccc"};
`;

export const CardContainer = styled.div`
	min-height: 500px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const Container = styled.div`
	display: flex;
	padding: 20px;
	align-items: center;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 32px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item,
	.ant-picker-input input {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;
